
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import _get from 'lodash.get';

import messages from '../config/localization.json';

Vue.use(VueI18n);

const fallbackLocale = 'en_US';

/**
 * Sets up Vue-i18n.
 *
 * Loading of the localization strings is taken care of by /middleware/localization-loader.js,
 * which works more reliably than async router guards in vue-router.
 *
 * @param {{}} opts opts
 */
export default function({app, query, params: {locale = 'en_US', ...args}}) {
    const production = process.env.NODE_ENV === 'production';

    app.i18n = new VueI18n({
        locale,
        messages,
        silentFallbackWarn: production,
        silentTranslationWarn: production,
        missing(targetLocale, key) {
            if (query.debug === 'translations') {
                return `{{ ${key} }}`;
            }
            // Return the correlated string from the fallbackLocale, if it exists, or finally the key itself, if it
            // doesn't.
            // eslint-disable-next-line security/detect-object-injection
            return _get(messages[fallbackLocale], key, key);
        }
    });
}
